$( document ).ready(function() {
    $("#user-notifications").click(function() {
        var notify = $("#user-notifications")[0];
        $('#list-user-notification').html('<div class="text-lg-center text-secondary" style="margin-top: 60px"><h3>Cargando...</h3></div>');

        if (notify.getAttribute('aria-expanded') == 'true'){
            $.ajax({
                type: "GET",
                contentType: "text/javascript",
                url: "/notifications",
            }).fail(function( jqXHR, textStatus, errorThrown ) {
               $('#notification-header').text("Error:" + errorThrown);
            });
        }

    });
});